<template>
  <div>
    <div class="h5-group-share-page share-page">
      <div class="cont-wrap">
        <!-- 标题 -->
        <p v-if="false" class="page-title">
          <span>拼团-{{ productInfo.course_name }}</span>
        </p>
        <div class="page-cont-wrap">
          <div class="group-info-cont page-top-wrap">
            <!-- 团长昵称||团状态 -->
            <div class="result">{{ leaderNickname }}</div>
            <!-- 拼团步骤 -->
            <p class="step">
              <span>下单支付</span>
              <span class="separate"></span>
              <span>邀好友拼团</span>
              <span class="separate"></span>
              <span>人满成团</span>
            </p>
            <!-- 拼团列表提示信息 -->
            <div class="active-info-message" v-html="userListMessage"></div>
            <!-- 成员列表 -->
            <div
              v-if="showMemberList"
              class="active-info-user-list"
              ref="userList"
            >
              <div
                class="user-list"
                :class="{ 'more-user-list': userLength > 5 }"
              >
                <div
                  class="user-item"
                  :class="{ 'user-item-leader': item.is_leader === 1 }"
                  v-for="(item, index) in groupInfo.memberList || {}"
                  :key="index"
                >
                  <div class="avater"><img :src="item.avatar" alt="" /></div>
                  <div class="name">{{ item.nickname.slice(0, 1) }}***</div>
                  <div class="leader-tag" v-if="index == 0">团长</div>
                  <div class="refund-tag" v-if="[1, 4].includes(item.state)">
                    {{ item.state === 4 ? "已退款" : "待支付" }}
                  </div>
                </div>
                <div
                  class="join-box"
                  v-for="(item, index) in new Array(groupInfo.diffNum).fill(
                    'a'
                  )"
                  :key="index + item"
                >
                  <span>待邀请</span>
                </div>
              </div>
            </div>
            <!-- 课程卡片 -->
            <H5CourseCard
              class="course-card"
              :courseInfo="productInfo"
              :activeInfo="groupInfo"
            />
            <!-- tab -->
            <div class="tab-box">
              <div
                :class="{
                  'tabs-fixed': detailNavFixed,
                  'electron-tab-fixed': isElectron,
                }"
                :style="'top:' + tabFixTop + 'px'"
              >
                <ul class="tabs-wrap">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{
                      active: item.id === activeId,
                      'course-tab': item.id === 2 && canTrial,
                    }"
                    @click="changeTab(item)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="course-detail-wrap">
            <!-- 详情 -->
            <div class="tab-content ql-snow" ref="detail">
              <CourseDescription
                :isH5="isH5"
                :courseDescription="productInfo.course_description || ''"
              />
            </div>
            <!-- 机构信息 -->
            <OrgCard
              :orgInfo="orgInfo"
              :isH5="isH5"
              :orgId="productInfo.org_id || ''"
            />
            <!-- 课程 -->
            <div class="tab-content course-cont" ref="course">
              <H5LessonList
                :isRegistered="productInfo.enrollment !== null"
                :unitList="productInfo.unit_list || []"
              />
            </div>
          </div>

          <!-- 温馨提示 -->
          <TipsText :orgInfo="orgInfo" />
        </div>
        <!-- 底部按钮 -->
        <!-- 未登录||未参与该拼团 -->
        <div class="fixed-bottom">
          <img
            @click="jumpOrgPage"
            class="org-logo"
            :src="handleOrgLogo"
            alt="logo"
          />
          <div v-show="isAuthenticated !== null" class="operate-wrap">
            <template v-if="!isAuthenticated || !isJoined">
              <!-- 待成团或已成团可超员参加 -->
              <div
                class="sign-up-btn"
                v-if="
                  groupInfo.state === 1 ||
                  (groupInfo.state === 2 && canExceed && !groupEnd)
                "
              >
                <button class="cretate-group" @click="signUp(0)">
                  发起拼团
                </button>
                <button class="join-group" @click="signUp(groupInfo.group_id)">
                  <span
                    class="price"
                    v-html="splitPrice(groupInfo.group_price)"
                  ></span
                  ><span class="text">加入此团</span>
                </button>
              </div>
              <!-- 已成团不可超员参加或已过期 -->
              <template v-else>
                <button @click="goProductDetail" class="text-btn">
                  查看课程
                </button>
                <button @click="signUp(0)" class="primary-btn create-group-btn">
                  发起拼团
                </button>
              </template>
            </template>
            <!-- 登录账号+已参与该拼团 -->
            <template v-else-if="isAuthenticated && isJoined">
              <!-- 待成团 -->
              <template v-if="groupInfo.state === 1">
                <button
                  @click="goGroupInfo"
                  class="wait-gtoup-text-btn text-btn"
                >
                  您已参团 <br v-if="isH5" />
                  还差
                  <span class="activity-color">{{ groupInfo.diffNum }}</span>
                  人成团
                </button>
                <button @click="shareGroup" class="share-group-btn">
                  分享拼团给好友
                </button>
              </template>
              <!-- 已成团 -->
              <template v-else-if="groupInfo.state === 2">
                <button @click="goGroupInfo" class="text-btn">
                  您已成团<br v-if="isH5" />
                  拼团详情
                </button>
                <button
                  @click="goLearningCenter"
                  class="primary-btn go-study-btn"
                >
                  开始学习
                </button>
              </template>
              <template v-else>
                <button @click="goGroupInfo" class="text-btn">拼团详情</button>
                <button @click="signUp(0)" class="primary-btn create-group-btn">
                  发起拼团
                </button>
              </template>
            </template>
          </div>
        </div>
      </div>
      <!-- 分享弹窗 -->
      <ShareDrawer ref="shareGroupDrawer" :productInfo="productInfo" />
    </div>
    <div id="confirm-order-container"></div>
  </div>
</template>

<script>
import share from "./share.js";
export default {
  mixins: [share],
  methods: {
    shareGroup() {
      const shareContent = `点击链接，一起 ${
        this.productInfo.group_set_info.price / 100
      } 元拼团购买原价 ${this.productInfo.goods.price / 100} 元的课程《${
        this.productInfo.course_name
      }》吧！`;
      const shareUrl = `${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${this.id}`;
      if (this.isHXApp) {
        this.copyShareUrl();
      } else if (this.isH5 && !this.isWeChat && !this.isQQ) {
        this.$refs.shareGroupDrawer.openDrawer({
          shareUrl, // 分享地址
          title: shareContent, // 分享标题
          pic: this.productInfo.cover_url,
          linkShowTitle: true,
          canJoinNum: this.groupInfo.diffNum,
          copyTostMsg: "链接已复制，可以发给好友啦",
        });
      } else {
        this.copyShareUrl();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h5-group-share-page {
  --group-share-h5-page-bg: #fff7f7;
  --group-share-h5-card-bg: #ffffff;
  --group-share-h5-soft-bg: #fff8f8;
  --group-share-h5-primary: #222426;
  --group-share-h5-secondary: #0d1400;
  --group-share-h5-muted: #858687;
  --group-share-h5-border: #efefef;
  --group-share-h5-hero-bg: url("../../../assets/images/group-activity/group-bg.png");
  --group-share-h5-fixed-shadow: 0rem 0.08rem 0.21rem 0rem rgba(102, 116, 107, 0.1);

  html.dark & {
    --group-share-h5-page-bg: var(--mg-bg-page);
    --group-share-h5-card-bg: var(--mg-bg-card);
    --group-share-h5-soft-bg: var(--mg-bg-surface);
    --group-share-h5-primary: var(--mg-text-primary);
    --group-share-h5-secondary: var(--mg-text-secondary);
    --group-share-h5-muted: var(--mg-text-muted);
    --group-share-h5-border: var(--mg-border-subtle);
    --group-share-h5-hero-bg: none;
    --group-share-h5-fixed-shadow: none;
  }

  background: var(--group-share-h5-page-bg);
  .ql-snow,
  .course-cont {
    padding-top: calc(1.23rem + #{$h5-open-app-height});
    margin-top: calc(-1.23rem - #{$h5-open-app-height});
    background: transparent !important;
  }
  .cont-wrap {
    padding-top: 0.24rem;
    min-height: 100vh;
    background: var(--group-share-h5-hero-bg), var(--group-share-h5-page-bg);
    background-size: 100% 11.24rem;
    background-repeat: no-repeat;
    padding-bottom: 3rem;
  }
  .page-title {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0 0.5333rem;
    height: 1.24rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      max-width: 80%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 600;
      font-size: 0.45rem;
      color: #ffffff;
      line-height: 0.64rem;
    }
  }
  .page-cont-wrap {
    margin: 0 auto;
    width: 9.36rem;
    padding: 0.4rem 0 0.67rem;
    background: var(--group-share-h5-card-bg);
    border-radius: 0.48rem;
    .result {
      font-weight: 600;
      font-size: 0.56rem;
      color: var(--group-share-h5-primary);
      line-height: 0.79rem;
      text-align: center;
      margin-bottom: 0.4rem;
    }
    .step {
      margin-bottom: 0.53rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0.93rem;
      background: var(--group-share-h5-soft-bg);
      border-radius: 0.24rem;
      font-weight: 500;
      font-size: 0.32rem;
      color: var(--group-share-h5-secondary);
      line-height: 0.44rem;
      .separate {
        width: 0.37rem;
        height: 0.37rem;
        background-image: url("../../../assets/images/product-details/rule-separate.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: 0 0.24rem;
      }
    }
    .active-info-message {
      font-weight: 600;
      font-size: 0.56rem;
      color: var(--group-share-h5-primary);
      line-height: 0.79rem;
      text-align: center;
      margin-bottom: 0.37rem;
    }
  }
  .group-info-cont {
    padding: 0 0.32rem;
  }
  .user-list {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 0 auto;
    padding-bottom: 0.27rem;
    .join-box {
      width: 1.07rem;
      background-image: url("../../../assets/images/group-activity/add_btn.png");
      background-repeat: no-repeat;
      background-size: 100% auto;
      margin: 0 0.33rem;
      span {
        width: 100%;
        text-align: center;
        display: inline-block;
        font-size: 0.29rem;
        color: var(--group-share-h5-muted);
        line-height: 0.4rem;
        padding: 1.36rem 0 0.4rem;
      }
    }
  }
  .more-user-list {
    justify-content: start;
  }
  .user-item {
    width: 1.07rem;
    margin: 0 0.33rem;
    position: relative;
    padding-bottom: 0.4rem;
    .avater {
      width: 1.07rem;
      height: 1.07rem;
      border: 0.01rem solid #ffe3ef;
      object-fit: cover;
      border-radius: 50%;
      overflow: hidden;
    }
    .name {
      font-size: 0.29rem;
      color: var(--group-share-h5-primary);
      line-height: 0.4rem;
      margin-top: 0.27rem;
      text-align: center;
    }
    .leader-tag {
      position: absolute;
      top: 0.77rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.99rem;
      height: 0.48rem;
      font-size: 0.32rem;
      color: #ffffff;
      line-height: 0.44rem;
      background: url("../../../assets/images/group-activity/leader-tag-bg.png");
      background-size: 100% 100%;
      z-index: 1;
    }
    .refund-tag {
      position: absolute;
      left: 0;
      top: 0;
      width: 1.07rem;
      height: 1.07rem;
      background: rgba(0, 0, 0, 0.5);
      border: 0.01rem solid #ffe3ef;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.29rem;
      color: #ffffff;
      line-height: 0.4rem;
      border-radius: 50%;
    }
  }
  .course-card {
    margin-bottom: 0.59rem;
  }

  .course-detail-wrap {
    background: var(--group-share-h5-card-bg);
    padding-bottom: 0.27rem;
  }

  // tab
  .tab-box {
    height: 0.8rem;
  }
  .tabs-wrap {
    display: flex;
    align-items: center;
    padding: 0 0 0.1rem 0;
    li {
      font-weight: 500;
      font-size: 0.43rem;
      color: var(--group-share-h5-primary);
      line-height: 0.43rem;
      padding-bottom: 0.2rem;
      margin-right: 0.67rem;
    }
    .course-tab {
      position: relative;
      &::after {
        position: absolute;
        content: "免费试学";
        display: block;
        left: 50%;
        top: 0.5rem;
        transform: translateX(-50%);
        width: 1.35rem;
        height: 0.48rem;
        font-weight: 600;
        font-size: 0.27rem;
        color: #ffffff;
        background: url("../../../assets/images/product-details/try-tag.png");
        background-size: 100% 100%;
        line-height: 0.37rem;
        text-align: center;
        padding-top: 0.11rem;
      }
    }
    .active {
      position: relative;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0.21rem;
        height: 0.08rem;
        border-radius: 0.04rem;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
      }
    }
  }

  .tabs-fixed {
    position: fixed;
    width: 100%;
    z-index: 2;
    background: var(--group-share-h5-card-bg);
    box-shadow: var(--group-share-h5-fixed-shadow);
    left: 0;
    top: $h5-open-app-height !important;
    .tabs-wrap {
      width: 100%;
      padding: 0.32rem 0 0.27rem 0.45rem;
      max-width: 100%;
      margin: 0 auto;
    }
    .course-tab:not(.active) {
      position: relative;
      &::after {
        display: none !important;
      }
    }
  }

  // 底部按钮
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 2.4rem;
    background: var(--group-share-h5-card-bg);
    border: 0.01rem solid var(--group-share-h5-border);
    padding: 0.27rem 0.32rem 0.85rem 0.45rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .org-logo {
      width: 1.07rem;
      height: 1.07rem;
      border: 0.01rem solid var(--group-share-h5-border);
      object-fit: cover;
      border-radius: 50%;
    }
    .share-group-btn {
      width: 4.32rem;
      height: 1.28rem;
      background: url("../../../assets/images/product-details/h5-share-group-btn.png");
      background-size: 100% 100%;
      font-weight: 500;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 0.44rem;
    }
    .text-btn.wait-gtoup-text-btn {
      margin-right: 0.92rem;
    }
    .text-btn {
      position: relative;
      text-align: left;
      font-weight: 500;
      font-size: 0.4rem;
      color: var(--group-share-h5-secondary);
      line-height: 0.56rem;
      margin-right: 1.9rem;
      span {
        color: #f03349;
      }
      &::after {
        position: absolute;
        content: "";
        right: -0.5rem;
        bottom: 0.04rem;
        display: block;
        // transform: translateY(-50%);
        width: 0.4rem;
        height: 0.4rem;
        background: url("../../../assets/images/product-details/text-btn-arrow.png");
        background-size: 100% 100%;
      }
    }
    .operate-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: end;
    }

    .sign-up-btn {
      width: 7.2rem;
      height: 1.4rem;
      padding-bottom: 0.12rem;
      background: url("../../../assets/images/product-details/h5-group-btn.png");
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      .cretate-group {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.33rem;
        margin-right: 0.2rem;
        color: var(--group-share-h5-secondary);
        font-size: 0.43rem;
        line-height: 0.43rem;
      }
      .join-group {
        flex: 1;
        .text {
          font-weight: 400;
          font-size: 0.32rem;
          color: #ffffff;
          line-height: 0.44rem;
        }
      }
      ::v-deep {
        .join-group {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: #fff;
          align-items: center;
          .price {
            display: flex;
            align-items: end;
          }
          .unit {
            font-weight: 800;
            font-size: 0.37rem;
            line-height: 1;
          }
          .integer {
            font-weight: 800;
            font-size: 0.59rem;
            line-height: 1;
          }
          .decimal {
            font-weight: 800;
            font-size: 0.4rem;
            line-height: 1;
          }
        }
      }
    }
  }
  .primary-btn {
    width: 4rem;
    height: 1.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.43rem;
    background: url("../../../assets/images/group-activity/view-btn-bg.png");
    background-size: 100% 100%;
  }
}
</style>
